import React from 'react';
import { arrayOf, object } from 'prop-types';
import styled from 'styled-components';

import Question from './Question';

const QuestionsBox = styled.div`
  @media(min-width: 1000px) {
    display: flex;
    flex-wrap: wrap;
    margin-bottom: 32px;
  }
`;

const QuestionsList = ({ questions }) => (
  <QuestionsBox>
    {questions.map(question => <Question key={question.title} question={question} />)}
  </QuestionsBox>
);

QuestionsList.propTypes = {
  questions: arrayOf(object).isRequired,
};

export default QuestionsList;
